export enum MigrationOption {
  ALL_ACTIVE = 'ALL_ACTIVE',
  LAST_24_MONTHS = 'LAST_24_MONTHS',
  SELECTED = 'SELECTED'
}

export enum MigrationStatus {
  NOT_STARTED = 'NOT_STARTED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ROLLED_BACK = 'ROLLED_BACK'
}

export interface MigrationMarketplaceAccount {
  advertiserId: string;
  marketplaceId: string;
}

export interface InitiateMigrationRequest {
  migrationOption: MigrationOption;
  subscriptionIds?: string[];
  marketplaceAccounts?: MigrationMarketplaceAccount[];
  email?: string;
}

export interface GetSubscriptionMigrationStatusRequest {
  subscriptionIds: string[];
}

export interface SubscriptionMigrationStatus {
  subscriptionId: string;
  source?: string;
  status: MigrationStatus;
  errorReason?: string;
  errorDetails?: string;
  reportCount?: number;
  reportsMigrated?: number;
  updatedAt?: string;
}

export interface GetSubscriptionMigrationStatusResponse {
  statuses: SubscriptionMigrationStatus[];
}
